<template>
  <div class="HallInfoEditPage">
    <!-- header start -->
    <van-nav-bar
      title="编辑纪念馆"
      right-text="保存"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    >
      <template #title>
        <label style="color: wheat" @click="onUpTitle">编辑纪念馆标题</label>
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-tabs
        v-model="curindex"
        @change="tabschange()"
        sticky
        animated
        swipeable
        offset-top="46"
        title-active-color="#fff"
        title-inactive-color="#f2f2f2"
        background="#24a378"
        color="#fff"
        :border="false"
      >
        <van-tab
          :title="item.DeceasedName"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="avatar-uploader">
            <van-uploader :after-read="afterRead" :max-count="1">
              <div class="avatar">
                <img v-if="curindex == 0" :src="img1" />
                <img v-else :src="img2" />
                <!-- <img v-else src="@/assets/images/create/m_member.png"/> -->
              </div>
            </van-uploader>
          </div>
          <div>
            <div class="field-item">
              <div class="hd"><i class="iconfont iconnav_me"></i></div>
              <div class="bd">
                <van-field v-model="item.DeceasedName" placeholder="姓名" />
              </div>
            </div>
            <div class="field-item" @click="selectSexShow = true">
              <div class="hd"><i class="iconfont iconm_sex"></i></div>
              <div class="bd">
                <van-field v-model="selectSex" readonly placeholder="性别" />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item" @click="showstartDate">
              <div class="hd"><i class="iconfont iconm_birthday-copy"></i></div>
              <div class="bd">
                <van-field v-model="startDate" readonly placeholder="生辰" />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item" @click="showendDate">
              <div class="hd"><i class="iconfont iconm_jr"></i></div>
              <div class="bd">
                <van-field v-model="endDate" readonly placeholder="忌日" />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item" @click="onzodiacShow">
              <div class="hd"><i class="iconfont iconm_zodiac"></i></div>
              <div class="bd">
                <van-field v-model="zodiac" readonly placeholder="生肖" />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item" @click="onxinyangShow">
              <div class="hd"><i class="iconfont iconm_love"></i></div>
              <div class="bd">
                <van-field v-model="xinyang" readonly placeholder="信仰" />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item" @click="onArealistShow">
              <div class="hd"><i class="iconfont iconm_gj"></i></div>
              <div class="bd">
                <van-field
                  v-model="areaListInput"
                  readonly
                  placeholder="籍贯"
                />
              </div>
              <div class="ft">
                <van-icon name="arrow" color="#999" size="16" />
              </div>
            </div>
            <div class="field-item">
              <div class="hd"><i class="iconfont iconm_address"></i></div>
              <div class="bd">
                <van-field
                  v-model="lifeAreaAddress"
                  @change="onChangeLifeAreaAddress"
                  placeholder="生活地址"
                />
              </div>
            </div>
            <div class="field-item">
              <div class="hd"><i class="iconfont iconm_my"></i></div>
              <div class="bd">
                <van-field
                  v-model="cemeteryAddress"
                  @change="onChangeCemeteryAddress"
                  placeholder="墓园地址"
                />
              </div>
            </div>
            <div class="field-item field-item-textarea">
              <div class="bd">
                <van-field
                  v-model="message"
                  rows="4"
                  type="textarea"
                  maxlength="150"
                  placeholder="逝者简述..."
                  @change="changeMessage"
                />
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      
   <div class="btn-area">
      <van-button @click="onClickRight()" class="mybtn" block
        >保存</van-button
      >
    </div>
    </div>

    <!-- <div class="fabBtn"><van-icon name="plus" size="30" color="#fff" /></div> -->

    <!-- 性别选择 popup start -->
    <van-popup v-model="selectSexShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="['女', '男']"
        cancel-button-text=""
        confirm-button-text="确定"
        :default-index="selectSex == '男' ? 1 : 0"
        :visible-item-count="3"
        @confirm="onConfirmSex"
        @cancel="selectSexShow = false"
      />
      <!-- @change="onSexChange" -->
    </van-popup>
    <!-- 性别选择 popup end -->
    <!-- 开始时间 popup start -->
    <van-popup v-model="startDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择生辰"
        v-model="currenDate"
        type="date"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirmstartDateShow"
        @cancel="startDateShow = false"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeNl(1)" style="width: 100%; padding: 5px">
              切换农历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanSc" style="width: 100%; padding: 5px">
              清除生辰
            </button>
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>

    <!-- 开始时间 popup end -->
    <van-popup v-model="nlShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="confirmNl"
        @cancel="nlShow = false"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeYl()" style="width: 100%; padding: 5px">
              切换阳历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanDate" style="width: 100%; padding: 5px">
              {{ dateType == 1 ? "清除生辰" : "清除忌日" }}
            </button>
          </div>
        </template>
      </van-picker>
    </van-popup>

    <!-- 结束时间 popup start -->
    <van-popup v-model="endDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择忌日"
        v-model="currenEndDate"
        type="date"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirmendDateShow"
        @cancel="endDateShow = false"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeNl(2)" style="width: 100%; padding: 4px">
              切换农历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanJr" style="width: 100%; padding: 4px">
              清除忌日
            </button>
          </div>
        </template>
      </van-datetime-picker>
      <!-- @change="endDateChange" -->
    </van-popup>
    <!-- 结束时间 popup end -->
    <!-- 选择省 / 市 / 区 popup start -->
    <van-popup v-model="arealistShow" position="bottom" :lazy-render="false">
      <!-- <van-area 
        :area-list="areaList" 
        :columns-num="3" 
        value="110101"
        @confirm="arealistShow = false"
        @cancel="arealistShow = false"
        @change="onAreaListChange"
      /> -->
      <van-picker
        ref="area"
        show-toolbar
        :columns="areacolumns"
        @cancel="arealistShow = false"
        @confirm="onConfirmArea"
      />
    </van-popup>
    <!-- 选择省 / 市 / 区 popup end -->

    <!-- 生肖 popup start -->
    <van-popup v-model="zodiacShow" position="bottom" :lazy-render="false">
      <van-picker
        ref="zodiac"
        show-toolbar
        :columns="zodiacList"
        @cancel="zodiacShow = false"
        @confirm="onConfirmZodiac"
      />
    </van-popup>
    <!-- 生肖 popup end -->
    <!-- 信仰 popup start -->
    <van-popup v-model="xinyangShow" position="bottom" :lazy-render="false">
      <van-picker
        ref="xinyang"
        show-toolbar
        :columns="xinyangList"
        @cancel="zodiacShow = false"
        @confirm="onConfirmXinyang"
      />
    </van-popup>
    <!-- 信仰 popup end -->

    <van-dialog
      v-model="isShowUpTitle"
      @confirm="onComUpTitle"
      show-cancel-button
    >
      <div class="field-item">
        <div class="hd"><i class="iconfont iconedit"></i></div>
        <div class="bd">
          <van-field v-model="memorialHall.Title" placeholder="请输入标题" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import AreaList from "@/assets/js/area";
import { Toast } from "vant";
export default {
  data() {
    return {
      id: "",
      selectSex: "",
      isShowUpTitle: false,
      selectSexShow: false,

      currenDate: new Date(),
      currenEndDate: new Date(),
      maxDate: new Date(),
      minDate: new Date("1800-01-01"),
      startDateShow: false,
      startDate: "",
      endDateShow: false,
      endDate: "",
      nlShow: false,
      curindex: 0,

      arealistShow: false,
      areaList: AreaList,
      areaListInput: "",
      dataList: null,
      zodiac: "",
      zodiacList: [],
      zodiacShow: false,
      zodiacindex: 0,
      areacolumns: [],

      lifeAreaAddress: "",
      cemeteryAddress: "",

      img1: "",
      img2: "",
      img2init: 0,

      xinyang: "",
      xinyangList: [],
      xinyangShow: false,

      message: "",
      changeImg: 0,
      memorialHall: null,
      input: {
        Base64ContentList: [],
        type: "MemorialManageEditDeceasedInformationVue",
      },
      s: null,
      dateType: 1,
      columns: [
        {
          values: ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"],
          defaultIndex: 0,
        },
        {
          values: [
            "子",
            "丑",
            "寅",
            "卯",
            "辰",
            "巳",
            "午",
            "未",
            "申",
            "酉",
            "戌",
            "亥",
          ],
          defaultIndex: 0,
        },
        {
          values: [
            "",
            "正",
            "二",
            "三",
            "四",
            "五",
            "六",
            "七",
            "八",
            "九",
            "十",
            "十一",
            "腊",
          ],
          defaultIndex: 0,
        },
        {
          values: [
            "",
            "初一",
            "初二",
            "初三",
            "初四",
            "初五",
            "初六",
            "初七",
            "初八",
            "初九",
            "初十",
            "十一",
            "十二",
            "十三",
            "十四",
            "十五",
            "十六",
            "十七",
            "十八",
            "十九",
            "二十",
            "廿一",
            "廿二",
            "廿三",
            "廿四",
            "廿五",
            "廿六",
            "廿七",
            "廿八",
            "廿九",
            "三十",
          ],
          defaultIndex: 0,
        },
      ],
    };
  },
  components: {},
  methods: {
    onUpTitle() {
      this.isShowUpTitle = true;
    },
    onComUpTitle() {
      var that = this;
      that.$store
        .dispatch({
          type: "UpdateMemorialHallTitle",
          id: that.memorialHall.SerialNumber,
          title: that.memorialHall.Title,
        })
        .then(
          (res) => {
            Toast(res.Message);
            if (res.IsSuccess) {
              that.isShowUpTitle = false;
            }
          },
          (err) => {}
        );
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      var that = this;
      if (that.changeImg == 1) {
        that.input.Base64ContentList[0] =
          that.curindex == 0 ? that.img1 : that.img2;
      }
      var postData = this.input;
      if (!(this.dataList[this.curindex].DeceasedName.length != 0)) {
        Toast("姓名不能为空");
        return;
      }
      Object.assign(postData, {
        Id: this.dataList[this.curindex].Id,
        deceasedName: this.dataList[this.curindex].DeceasedName,
        gender: this.dataList[this.curindex].Gender,
        birthdayDateTime: this.dataList[this.curindex].BirthdayDateTime,
        passAwayDateTime: this.dataList[this.curindex].PassAwayDateTime,
        zodiac: this.dataList[this.curindex].Zodiac,
        faith: this.dataList[this.curindex].Faith,
        lifeAreaAddress: this.dataList[this.curindex].LifeAreaAddress,
        cemeteryAddress: this.dataList[this.curindex].CemeteryAddress,
        departedSketch: this.dataList[this.curindex].DepartedSketch,
        originalhome: this.dataList[this.curindex].Originalhome,
      });
      this.$store.dispatch(postData).then(
        (res) => {
          if (res.IsSuccess) {
            Toast(that.dataList[that.curindex].DeceasedName + "修改成功");
            if (that.s) {
              that.$router.replace("/");
            }
          }
        },
        (err) => {}
      );
    },
    //初始化tabs数据
    tabschange() {
      this.selectSex =
        this.dataList[this.curindex].Sex != null
          ? this.dataList[this.curindex].Sex
          : "";
      this.startDate =
        this.dataList[this.curindex].BirthdayDateTime != null
          ? this.$moment(this.dataList[this.curindex].BirthdayDateTime).format(
              "YYYY-MM-DD"
            )
          : "";
      this.endDate =
        this.dataList[this.curindex].PassAwayDateTime != null
          ? this.$moment(this.dataList[this.curindex].PassAwayDateTime).format(
              "YYYY-MM-DD"
            )
          : "";
      this.areaListInput =
        this.dataList[this.curindex].OriginalhomeAddress != null
          ? this.dataList[this.curindex].OriginalhomeAddress
          : "";
      this.zodiac =
        this.dataList[this.curindex].Zodiac != null
          ? this.dataList[this.curindex].Zodiac
          : "";
      this.xinyang =
        this.dataList[this.curindex].Faith != null
          ? this.dataList[this.curindex].Faith
          : "";
      this.lifeAreaAddress =
        this.dataList[this.curindex].LifeAreaAddress != null
          ? this.dataList[this.curindex].LifeAreaAddress
          : "";
      this.cemeteryAddress =
        this.dataList[this.curindex].CemeteryAddress != null
          ? this.dataList[this.curindex].CemeteryAddress
          : "";
      this.message =
        this.dataList[this.curindex].DepartedSketch != null
          ? this.dataList[this.curindex].DepartedSketch
          : "";

      this.input.birthdayDateMode =
        this.dataList[this.curindex].BirthdayDateMode != null
          ? this.dataList[this.curindex].BirthdayDateMode
          : "";

      this.input.nlBirthdayList =
        this.dataList[this.curindex].NlBirthdayList != null
          ? this.dataList[this.curindex].NlBirthdayList
          : null;

      this.input.passAwayDateMode =
        this.dataList[this.curindex].PassAwayDateMode != null
          ? this.dataList[this.curindex].PassAwayDateMode
          : "";

      this.input.nlPassAwayList =
        this.dataList[this.curindex].NlPassAwayList != null
          ? this.dataList[this.curindex].NlPassAwayList
          : "";
      if (this.input.birthdayDateMode == 4) {
        this.startDate = this.dataList[this.curindex].BirthdayDateDesc;
      }

      if (this.input.passAwayDateMode == 4) {
        this.endDate = this.dataList[this.curindex].PassAwayDateDesc;
      }

      // 初始化图片
      if (this.img2init == 0) {
        if (this.curindex == 0) {
          this.img1 =
            this.dataList[this.curindex].HeadPhoto != null
              ? this.dataList[this.curindex].HeadPhoto
              : "@/assets/images/create/m_member.png";
        } else {
          this.img2 =
            this.dataList[this.curindex].HeadPhoto != null
              ? this.dataList[this.curindex].HeadPhoto
              : "@/assets/images/create/m_member.png";
          this.img2init = 1;
        }
      }
    },
    // 改变性别
    onSexChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.selectSex = value;
    },
    onConfirmSex(v, index) {
      this.selectSex = v;
      this.dataList[this.curindex].Sex = v;
      this.dataList[this.curindex].Gender = index + 1;
      this.selectSexShow = false;
    },
    // 生辰
    startDateChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.startDate =
        dateArray[0].replace("年", "") +
        "-" +
        dateArray[1].replace("月", "") +
        "-" +
        dateArray[2].replace("日", "");
    },
    confirmstartDateShow(v) {
      var tempdate = this.$moment(v).format("YYYY-MM-DD");
      this.dataList[this.curindex].BirthdayDateTime = tempdate;
      this.startDate = tempdate;
      this.startDateShow = false;
    },
    confirmNl(v, i) {
      //console.log(v,i,"confirmNl");
      var _text = v.toString().replaceAll(",", "");
      if (this.dateType == 1) {
        this.startDate = _text;
        this.input.birthdayDateMode = 4;
        this.input.nlBirthdayList = i;
      } else if (this.dateType == 2) {
        this.endDate = _text;
        this.input.passAwayDateMode = 4;
        this.input.nlPassAwayList = i;
      }
      this.nlShow = false;
    },
    showstartDate() {
      this.startDateShow = true;
      this.currEndDate = new Date(this.startDate);
    },
    // 忌日
    endDateChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.endDate =
        dateArray[0].replace("年", "") +
        "-" +
        dateArray[1].replace("月", "") +
        "-" +
        dateArray[2].replace("日", "");
    },
    confirmendDateShow(v) {
      var tempdate = this.$moment(v).format("YYYY-MM-DD");
      this.dataList[this.curindex].PassAwayDateTime = tempdate;
      this.endDate = tempdate;
      this.endDateShow = false;
    },
    showendDate() {
      this.endDateShow = true;
      this.currenEndDate = new Date(this.endDate);
    },
    // 地区
    onConfirmArea(value, indexs) {
      this.arealistShow = false;
      this.areaListInput = value[0] + value[1] + value[2];
      this.dataList[this.curindex].AreaIndexList = indexs;
      this.dataList[this.curindex].OriginalhomeAddress = this.areaListInput;
      this.dataList[this.curindex].Originalhome =
        "~3716~" +
        this.areacolumns[indexs[0]].id +
        "~" +
        this.areacolumns[indexs[0]].children[indexs[1]].id +
        "~" +
        this.areacolumns[indexs[0]].children[indexs[1]].children[indexs[2]].id +
        "~";
    },
    onArealistShow() {
      this.arealistShow = true;
      if (this.dataList[this.curindex].AreaIndexList != null) {
        this.$refs.area.setIndexes(this.dataList[this.curindex].AreaIndexList);
      } else {
        this.$refs.area.setIndexes([0, 0, 0]);
      }
    },
    // 生肖
    onConfirmZodiac(v, i) {
      this.zodiac = v;
      this.zodiacShow = false;
      this.dataList[this.curindex].Zodiac = v;
    },
    onzodiacShow(zodiacShow) {
      this.zodiacShow = true;
      var index = this.zodiacList.indexOf(this.zodiac);
      if (index > -1) {
        this.$refs.zodiac.setIndexes([index]);
      } else {
        this.$refs.zodiac.setIndexes([0]);
      }
    },
    // 处理信仰
    onConfirmXinyang(v, i) {
      this.xinyang = v;
      this.xinyangShow = false;
      this.dataList[this.curindex].Faith = v;
    },
    onxinyangShow() {
      this.xinyangShow = true;
      var index = this.xinyangList.indexOf(this.xinyang);
      if (index > -1) {
        this.$refs.xinyang.setIndexes([index]);
      } else {
        this.$refs.xinyang.setIndexes([0]);
      }
    },
    // 更改生活地址
    onChangeLifeAreaAddress(v) {
      this.dataList[this.curindex].LifeAreaAddress = this.lifeAreaAddress;
    },
    // 更改墓园地址
    onChangeCemeteryAddress(v) {
      this.dataList[this.curindex].CemeteryAddress = this.cemeteryAddress;
    },
    // 更改简述
    changeMessage() {
      this.dataList[this.curindex].DepartedSketch = this.message;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },
    /*选择省 / 市 / 区*/
    onAreaListChange(picker) {
      var areaValue = picker.getValues();
      this.areaListInput =
        areaValue[0].name +
        " / " +
        areaValue[1].name +
        " / " +
        areaValue[2].name;
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "MemorialManageGetDeceasedInformationList",
          memorialHallId: that.id,
        })
        .then(
          (res) => {
            that.dataList = res.DeceasedInformationApiModelList;
            that.memorialHall = res.MemorialHall;
            that.getZodiacList(res);
            that.getXinyangList(res);
            that.tabschange();
            // that.input.birthdayDateMode=4;
            // that.input.nlBirthdayList="";
            // that.input.passAwayDateMode=4;
            // that.input.nlPassAwayList="";
          },
          (err) => {}
        );
      this.getAreaList();
    },
    // 初始化信仰数据
    getXinyangList(res) {
      var that = this;
      if (res.XinyangList) {
        for (var i = 0; i < res.XinyangList.length; i++) {
          // 加载信仰数据
          // var temp = {
          //   id : res.XinyangList[i].ID,
          //   text : res.XinyangList[i].DescName,
          // };
          // that.xinyangList.push(temp);
          that.xinyangList.push(res.XinyangList[i].DescName);
        }
      }
    },
    // 初始化生肖数据
    getZodiacList(res) {
      var that = this;
      if (res.ZodiacList) {
        for (var i = 0; i < res.ZodiacList.length; i++) {
          // 加载生肖
          // var temp = {
          //   id : res.ZodiacList[i].ID,
          //   text : res.ZodiacList[i].DescName,
          // };
          // that.zodiacList.push(temp);
          that.zodiacList.push(res.ZodiacList[i].DescName);
        }
      }
    },
    // 初始化地区数据
    getAreaList() {
      var that = this;
      that.$store
        .dispatch({
          type: "GetAreasListVue",
        })
        .then(
          (res) => {
            res.map((e) => {
              e.children.map((c) => {
                if (!c.children) {
                  c.children = Object.assign(
                    [],
                    [
                      {
                        children: null,
                        id: "-1",
                        text: "",
                      },
                    ]
                  );
                }
              });
            });
            that.areacolumns = res;
          },
          (err) => {}
        );
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var that = this;
      //console.log(file);
      this.changeImg = 1;
      if (that.curindex == 0) {
        this.img1 = file.content;
      } else {
        this.img2 = file.content;
      }
    },
    changeNl(type) {
      if (type == 1) {
        this.startDateShow = false;
      } else {
        this.endDateShow = false;
      }
      this.nlShow = true;
      this.dateType = type;
    },
    changeYl() {
      this.nlShow = false;
      if (this.dateType == 1) {
        this.startDateShow = true;
      } else {
        this.endDateShow = true;
      }
    },
    cleanSc() {
      //清除生辰
      this.startDate = "";
      this.currenDate = "";
      this.dataList[this.curindex].BirthdayDateTime = "";
      this.startDateShow = false;
    },
    cleanJr() {
      //清除忌日
      this.endDate = "";
      this.currenEndDate = "";
      this.dataList[this.curindex].PassAwayDateTime = "";
      this.endDateShow = false;
    },
    cleanDate() {
      if (this.dateType == 1) {
        this.startDate = "";
        this.currenDate = "";
        this.startDateShow = false;
      } else {
        this.endDate = "";
        this.currenEndDate = "";
        this.endDateShow = false;
      }
      this.nlShow = false;
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.id = this.$route.params.id;
    } else {
      this.id = this.$route.query.id;
      this.s = this.$route.query.s;
    }
    this.init();
  },
};
</script>

<style scoped>
.HallInfoEditPage .avatar-uploader {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
}
.HallInfoEditPage .avatar-uploader .avatar {
  width: 130px;
  height: 130px;
  background: url("~@/assets/images/create/m_avatar_bg02.png") center no-repeat;
  background-size: cover;
}
.HallInfoEditPage .avatar-uploader .avatar img {
  width: 100%;
  height: 100%;
  background-size: cover;
  padding: 12px;
  border-radius: 50%;
}
.HallInfoEditPage .avatar-uploader .tips {
  font-size: 12px;
  color: #fff;
  text-align: center;
}
.HallInfoEditPage .field-item {
  display: flex;
  align-items: center;
  margin: 21px 15%;
  background-color: #fff;
  padding: 0 15px;
  height: 48px;
  border-radius: 3px;
  border: 1px solid #eee;
}
.HallInfoEditPage .field-item-textarea {
  height: auto !important;
  padding: 15px;
}
.HallInfoEditPage .field-item > .hd {
  margin-right: 12px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.HallInfoEditPage .field-item > .hd i {
  font-size: 21px;
  color: #666;
}
.HallInfoEditPage .field-item > .hd img {
  width: 21px;
  height: 21px;
  object-fit: contain;
}
.HallInfoEditPage .field-item > .bd {
  flex: 1;
  overflow: hidden;
}
.HallInfoEditPage .field-item > .ft {
  margin-left: 15px;
  display: flex;
  align-items: center;
}
.HallInfoEditPage .field-item .van-cell {
  padding: 0;
  background-color: transparent !important;
}
.HallInfoEditPage .field-item .van-field__control {
  color: #222;
}
.fabBtn {
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #24a378;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(0, 0, 0, 0.28);
}
</style>
